import { execute } from '@/api/execute'
import { GET, PUT, POST, DELETE } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'dashboard/mixers'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/brands/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/brands/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/brands/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/brands/${id}`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/brands/${id}/`)
  },

  listModelsByBrand (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/models/`, params))
  },

  createModel (payload) {
    return execute(POST, `${ENDPOINT}/models/`, payload)
  },

  getModelById (id) {
    return execute(GET, `${ENDPOINT}/models/${id}/`)
  },

  updateModel (id, payload) {
    return execute(PUT, `${ENDPOINT}/models/${id}/`, payload)
  },

  deleteModel (id) {
    return execute(DELETE, `${ENDPOINT}/models/${id}/`)
  },

  listCalibrationsByModel (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/items/`, params))
  },

  createCalibration (payload) {
    return execute(POST, `${ENDPOINT}/items/`, payload)
  },

  getCalibrationById (id) {
    return execute(GET, `${ENDPOINT}/items/${id}/`)
  },

  updateCalibration (id, payload) {
    return execute(PUT, `${ENDPOINT}/items/${id}/`, payload)
  },

  deleteCalibration (id) {
    return execute(DELETE, `${ENDPOINT}/items/${id}/`)
  }
}
